<template>
  <div
    class="auth-wrapper pr-15 pl-15"
    :style="{
      backgroundImage: 'url(' + $store.getters[`customization/loginBg`] + ')'
    }"
  >
    <div class="language">
      <LanguageBar />
    </div>
    <b-row class="register-form h-300">
      <LoadingAnimation :title="$t('text.verify_invitation')" v-if="loading" />
      <div v-else class="verify-invitation-result">
        <!-- After user complete sign in / sign up flow, then show accept and decline button -->
        <div v-if="showAcceptOrDecline">
          <div>
            <i class="result-icon el-icon-success success-icon"></i>
          </div>
          <div class="mb-20">
            <b>{{ invitationInfo.username }}</b> {{ $t('text.has_invited') }}
            <b>{{ invitationInfo.email }}</b> {{ $t('text.to_join') }}
            <b>{{ invitationInfo.organisationName }}</b
            >.
          </div>
          <el-button
            @click="joinOrganistion()"
            :loading="acceptLoading"
            :disabled="acceptLoading"
            type="primary"
            >{{ $t('text.accept') }}</el-button
          >
          <el-button
            @click="decline()"
            :disabled="declineLoading"
            :loading="declineLoading"
            >{{ $t('text.decline') }}</el-button
          >
        </div>
        <!-- else show error message -->
        <div v-else>
          <div>
            <i
              class="result-icon"
              :class="
                verifyResult.status
                  ? 'el-icon-success success-icon'
                  : 'el-icon-error failed-icon'
              "
            ></i>
          </div>
          <div class="result-title">
            {{
              verifyResult.status
                ? $t('text.verification_passed')
                : $t('text.verification_failed')
            }}
          </div>
          <div class="result-msg" v-html="verifyResult.msg"></div>
        </div>
      </div>
      <OrganisationSelection
        ref="organisationSelection"
        :organisations="organisations"
        @assignPermissionSuccess="$router.push('/')"
      />
      <CompleteOrganisationInfo ref="completeOrganisationInfo" />
    </b-row>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import LanguageBar from '@/components/LanguageBar.vue'
import LoadingAnimation from '@/components/patients/charts/LoadingAnimation'
import OrganisationSelection from '@/components/signIn/OrganisationSelection.vue'
import CompleteOrganisationInfo from '@/components/signIn/CompleteOrganisationInfo.vue'
import '@/assets/font/font.css'
import '@/assets/css/login.scss'
import '@/assets/css/global.scss'
export default {
  data() {
    return {
      loading: false,
      verifyResult: {
        status: false,
        msg: null
      },
      showAcceptOrDecline: false,
      invitationInfo: null,
      acceptLoading: false,
      declineLoading: false,
      organisations: []
    }
  },
  components: {
    LanguageBar,
    LoadingAnimation,
    OrganisationSelection,
    CompleteOrganisationInfo
  },
  mounted() {
    const storedInvitationInfo = localStorage.getItem('invitationInfo')
    const invitationRegion =
      this.$route.query.region ||
      (storedInvitationInfo ? JSON.parse(storedInvitationInfo).region : '')

    this.$store
      .dispatch('region/useRegionApi', invitationRegion)
      .then(() => this.initializeInvitationFlow())
      .catch(error => {
        this.verifyResult = {
          status: false,
          msg: error.message
        }
      })
  },
  methods: {
    initializeInvitationFlow() {
      this.getOrganisatons()

      // if url with invitation token, then verify code correct
      if (this.$route.query.invitationToken) {
        this.verifyInvitation()
      }

      // if url with completeSignIn, then show accept and decline button, go through invitation work flow
      if (this.$route.query.completeSignIn) {
        this.showAcceptOrDecline = true
        let invitationInfo = localStorage.getItem('invitationInfo')
        if (invitationInfo) {
          this.invitationInfo = JSON.parse(invitationInfo)
        }
      }
    },
    getOrganisatons() {
      let user = localStorage.getItem('user')
      if (!user) {
        this.organisations = []
        return
      }
      user = JSON.parse(user)
      this.organisations = user.organisations
    },
    verifyInvitation() {
      this.loading = true
      ApiService.VerifyInvitation(this.$route.query.invitationToken)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            let data = response.data.data

            // Mock Data
            // data = {
            //   invitationCode: data.invitationCode,
            //   organisationId: '11111',
            //   organisationName: `Lucille's organisation 2`,
            //   username: 'Lucille Wang',
            //   email: ''
            // }
            this.invitationInfo = {
              ...data,
              region: this.$store.state.region.currentRegion
            }

            // If login user is invitation user, then show accept and decline button
            let loggedIn = localStorage.getItem('user')
            if (loggedIn) {
              loggedIn = JSON.parse(loggedIn)
              if (loggedIn.email === this.invitationInfo.email) {
                this.showAcceptOrDecline = true
              } else {
                this.showNotSignInMsg()
                // if loggin user in not the invitation user, then logout current user, then go to sign in page
                this.setInvitationInfoToLocalstorage()
                this.$store.dispatch('user/logout')
              }
            } else {
              this.showNotSignInMsg()
              // If user not login, then go to sign in page, after completing sign in work flow, then accept invitation
              this.handleNoLogin()
            }
          } else {
            this.verifyResult = {
              status: false,
              msg: this.getErrorMsg(response.data.errorcode)
            }
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    showNotSignInMsg() {
      this.verifyResult = {
        status: true,
        msg: this.$t('text.verify_error_msg_not_sign_in')
      }
    },
    getErrorMsg(code) {
      let msg = null
      switch (code) {
        case 620:
          msg = this.$t('text.verify_error_msg_620')
          break
        case 622:
          msg = this.$t('text.verify_error_msg_622')
          break
        case 801:
          msg = this.$t('text.verify_error_msg_801')
          break
        case 802:
          msg = this.$t('text.verify_error_msg_802')
          break
        case 803:
          msg = this.$t('text.verify_error_msg_803')
          break
        case 804:
          msg = this.$t('text.verify_error_msg_804')
          break
        case 805:
          msg = this.$t('text.verify_error_msg_805')
          break
      }
      return msg
    },
    joinOrganistion() {
      if (!(this.invitationInfo && this.invitationInfo.invitationCode)) {
        return false
      }
      this.acceptLoading = true
      ApiService.JoinOrganisation(this.invitationInfo.invitationCode)
        .then(response => {
          this.acceptLoading = false
          if (response.data.success) {
            this.handleJoinOrganisationSuccess()
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text:
                this.getErrorMsg(response.data.errorcode) || response.data.msg
            })
            // let errorMsg =
            //   this.getErrorMsg(response.data.errorcode) || response.data.msg
            // this.verifyResult = {
            //   status: false,
            //   msg: errorMsg
            // }
          }
        })
        .catch(() => {
          this.acceptLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    handleJoinOrganisationSuccess() {
      this.acceptLoading = true
      localStorage.removeItem('invitationInfo')
      this.$store.dispatch('user/verifyUser').then(() => {
        this.getOrganisatons()
        if (this.organisations.length > 1) {
          this.showOrganisationSelection()
        } else {
          this.verifyResult = {
            status: true,
            msg: this.$t('text.verify_success_msg')
          }
          this.$router.push('/')
        }
      })
    },
    showOrganisationSelection() {
      this.$refs.organisationSelection.openDialog()
    },
    handleNoLogin() {
      setTimeout(() => {
        this.setInvitationInfoToLocalstorage()
        this.$router.push('/sign-in')
      }, 1000)
    },
    decline() {
      this.declineLoading = true
      let tokenInfo = localStorage.getItem('tokenInfo')
      if (!tokenInfo) {
        this.declineLoading = false
        return
      }
      let loggedIn = localStorage.getItem('user')
      if (loggedIn) {
        localStorage.removeItem('invitationInfo')
        this.$store
          .dispatch('region/restorePreferredRegionApi')
          .then(() => this.$store.dispatch('user/verifyUser'))
          .then(() => {
            this.getOrganisatons()
            if (this.organisations.length > 1) {
              this.showOrganisationSelection()
            } else {
              this.$router.push('/')
            }
          })
          .finally(() => {
            this.declineLoading = false
          })
      } else {
        // If user have no oraganisation, then user should complete organisation information
        this.$refs.completeOrganisationInfo.openDialog()
        this.declineLoading = false
      }
    },
    setInvitationInfoToLocalstorage() {
      localStorage.setItem(
        'invitationInfo',
        JSON.stringify(this.invitationInfo)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-wrapper .register-form {
  .common-btn {
    width: 100%;
  }
}
</style>
